import { hexStripZeros } from "@ethersproject/bytes"
import type { Provider } from "@ethersproject/providers"
import type { AbiItem } from "web3-utils"

import { fetcher } from "common/helpers/fetcher"
import { BlockExplorerType } from "web3/constants/chains"

type ContractData = {
  status: "0" | "1"
  result: string
  message: string
}

/*
  As per EIP-1967:
    LOGIC_CONTRACT_ADDRESS holds the address of the logic contract that this proxy delegates to
    
    ref: https://eips.ethereum.org/EIPS/eip-1967#logic-contract-address
*/
const LOGIC_CONTRACT_ADDRESS =
  "0x360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc"

export async function getAddresses(address: string, provider: Provider) {
  async function getProxyAddress(address: string) {
    const proxyAddress = await provider.getStorageAt(
      address,
      LOGIC_CONTRACT_ADDRESS,
    )

    return hexStripZeros(proxyAddress)
  }

  const proxyAddress = await getProxyAddress(address)

  return proxyAddress !== "0x" ? [address, proxyAddress] : [address]
}

export function getEndpoints(
  addresses: string[],
  chain: { url: string; type: string; apiKey: string },
) {
  return addresses.map((address) => {
    const url = new URL(chain.url)

    const searchParams = new URLSearchParams()

    searchParams.append("address", address)
    searchParams.append("action", "getabi")
    searchParams.append("module", "contract")
    searchParams.append(
      "apikey",
      chain.type === BlockExplorerType.Etherscan
        ? process.env.NEXT_PUBLIC_ETHERSCAN_API_KEY
        : chain.apiKey,
    )

    url.search = searchParams.toString()

    return url.href
  })
}

export function getContractData(endpoint: string) {
  return fetcher
    .rest<ContractData>({ endpoint, error: { shouldOmit: true } })
    .then((data) => {
      if (data && data.status === "1" && data.result) {
        return JSON.parse(data.result) as AbiItem[]
      } else {
        return []
      }
    })
}
